export enum IMPORT_STATUS {
  IMPORTED = "imported",
  FAILED = "failed",
  PROCESSING = "processing",
  ERRORS = "errors",
}

export enum FILE_IMPORT_TYPE {
  USER = "User",
  ADDRESS = "Address",
  ADDRESS_V2 = "Address V2",
  CONTACT = "Contact",
  TRACKER = "Tracker",
  TRACKER_V2 = "Tracker V2",
  RATE_CARD = "Rate card",
}

type File = {
  attachment: string;
  extension: string;
  file_type: number;
  filename: string;
  id: number;
  reference_number: string;
  size: string;
};

export type FileImportJobAction = {
  created: string;
  errors: string | null;
  status: IMPORT_STATUS;
  total_failed_rows: number;
  total_imported_rows: number;
  uploaded_file: File;
  imported_file: File;
};

export type FileImportDetailsType = {
  total_successful_rows: number;
  file_import_job: {
    action: string;
    created: string;
    created_by: string;
    data_type: FILE_IMPORT_TYPE;
    description: string;
    id: number;
  };
  latest_import_job_action: FileImportJobAction;
};
